export default {
      id: "profile-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#profile",
      toString: function () {
        return this.url;
      }
    }